import clsx from "clsx";
import Image from "components/Elements/Image/Image.tsx";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import Authentication from "components/Reusable/Authentication";
import Logo from "../../Reusable/Logo";

import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useUser } from "contexts/userContext/userContext";
import { useEffect } from "react";

import styles from "./authenticationPage.module.scss";

interface AuthenticationPageI extends React.HTMLAttributes<HTMLDivElement> {
  type: "sign-in" | "sign-up";
}

const isCurrDomainOrgDomain = checkCurrDomainIsOrgDomain();

const AuthenticationPage = (props: AuthenticationPageI) => {
  const { type, className, ...restProps } = props;

  const { isLoggedIn } = useUser();

  useEffect(() => {
    if (isLoggedIn()) {
      window.location.href = `home`;
    }
  }, [isLoggedIn()]);

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      {isCurrDomainOrgDomain ? null : <Logo color="black" />}
      <Authentication type={type} className={styles.modal} />
      {isCurrDomainOrgDomain ? null : (
        <div className={styles.linkMainPage}>
          {/*@ts-ignore*/}
          <LinkToNewTab page="home">www.jumbomail.me</LinkToNewTab>
        </div>
      )}
      <Image className={styles.clouds} name="sub-user-complete" ext="svg" />
    </div>
  );
};

export default AuthenticationPage;
